<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-5 col-md-12 mb-4">
                      <h2>Offerings</h2>
                      <div class="ims-tab ml-0">
                        <router-link to="/ims/ims-offering" class="inv-btn" v-if="isTrader || isAdmin || isEditor">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='imsMyOfferinglist' }" >
                              My Offerings
                          </button>
                        </router-link>
                        <router-link to="/ims/ims-offering/alloffering">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='imsAllOfferinglist' }" >
                              All Offerings
                          </button>
                        </router-link>
                        <router-link to="/ims/ims-offering/importdata">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='imsimportdata' }" >
                            Imported Data
                          </button>
                        </router-link>
                      </div>
                    </div>
                    <div class="col-lg-7 col-md-12 text-right">
                      <div class="d-inline-flex justify-content-end mt-3">
                          <button type="button" @click="exportToExcel()" class="btn btn-sm  btn-secondary  rounded">
                            <i v-if="!exporting" class="fas fa-download"></i> 
                            <i v-if="exporting" class="fa fa-spinner fa-spin"></i>
                            EXPORT
                          </button>
                          <div class="dropdown">
                          <button :disabled="offerUploadStatus == 'INPROGRESS'" class="btn btn-secondary  rounded dropdown-toggle ml-2 mt-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                             <div v-if="offerUploadStatus == 'INPROGRESS'" style="color:black">
                              <i class="fa fa-spinner fa-spin"></i>  IMPORTING..
                            </div> 
                            <div v-if="!offerUploadStatus">
                              <i class="fas fa-upload"></i>  IMPORT
                            </div>  
                          </button>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item cursor-pointer" @click="openImportOfferingModal()">Offerings</a>
                            <a class="dropdown-item cursor-pointer" @click="openImportCusipModal()">Cusips</a>
                          </div>
                        </div>
                        <!-- <button  @click="openAddOfferModal()" type="button" class="btn btn-sm  btn-secondary  rounded ml-2"><i class="fas fa-user-plus"></i> ADD</button> -->
                        <!-- <button @click="changeOfferStatusToSendToEcn()" type="button" class="btn btn-sm  btn-secondary rounded ml-2"><i class="fa fa-history"></i>Rearrange Priority Offers</button> -->
                        <button :disabled="settings.isSendToEcn"  @click="uploadDaily()" type="button" class="btn btn-sm  btn-success rounded ml-2"><i class="fas fa-upload"></i>DAILY UPLOAD</button>
                        <!-- <button :disabled="!settings.isSendToEcn"  @click="reuploadAllEcns()" type="button" class="btn btn-sm  btn-secondary  rounded dropdown-toggle ml-2 mt-0"><i class="fas fa-upload"></i> REUPLOAD</button>  -->
                        <div class="dropdown">
                          <button class="btn btn-secondary  rounded dropdown-toggle ml-2 mt-0" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <div>
                              ACTIONS <i class="fa fa-arrow-circle-down"></i>  
                            </div>  
                          </button>
                          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton2">
                            <a class="dropdown-item cursor-pointer" @click="openAddOfferModal()">ADD</a>
                            <!-- <a class="dropdown-item cursor-pointer text-uppercase" @click="changeOfferStatusToSendToEcn()">Rearrange Priority Offers</a> -->
                            <!-- <a class="dropdown-item cursor-pointer text-uppercase" @click="cancelOfferingUpload()">Cancel offering upload</a> -->
                            <a v-bind:class="{ 'disable-link': !settings.isSendToEcn }" class="dropdown-item cursor-pointer" @click="reuploadAllEcns()">REUPLOAD</a>
                          </div>
                        </div>           

                        </div>
                    </div>
                </div>
                <!-- Card stats -->
                </div>
            </div>
        </div>
        <router-view></router-view>
        <ImportOfferings
            v-if="importOfferingModalOpen" 
            @close="closeImportOfferingModal()"
         /> 
         <CreateOffer
            v-if="addNewOfferModalOpen" 
            v-bind:mode="'ADD'"  
            @close="addNewOfferModalOpen = false">
        </CreateOffer>
        <ImportCusipOfferings 
          v-if="importCusipModalOpen" 
          @close="importCusipModalOpen = false"
        />
    </div> 
        
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import ImportOfferings from "./ImsImportOfferingModal";
import CreateOffer from "./ImsAddOfferModal";
import ImportCusipOfferings from "./ImsImportCusipModal";
export default {
  name: "imsOfferListComponent",
  components : {
     ImportOfferings,
     CreateOffer,
     ImportCusipOfferings
  },
  data() {
    return {
        accessToken: null,
        loading : false,
        selectedCusip : "",
        offerings:[],
        importOfferingModalOpen : false,
        addNewOfferModalOpen : false,
        importCusipModalOpen : false,
        searchValue : "",
        fromDate : "",
        toDate : "",
        isAdmin: false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,
        settings : {isSendToEcn : true},
        exporting : false,
        offerUploadStatus : localStorage.getItem("OFFERUPLOADSTATUS")


    };
  },
  methods: {
    openImportOfferingModal(){
      this.importOfferingModalOpen = true
    },
    closeImportOfferingModal(){
      this.importOfferingModalOpen = false;
      this.offerUploadStatus = localStorage.getItem("OFFERUPLOADSTATUS");
    },
    openAddOfferModal(){
      this.addNewOfferModalOpen = true;
    },
    openImportCusipModal(){
      this.importCusipModalOpen = true;
    },
    exportToExcel(){
      this.exporting = true;
      // var fDate = this.moment(this.fromDate).format("YYYY-MM-DD");
      // var tDate = this.moment(this.toDate).format("YYYY-MM-DD");
      // if(this.moment(this.fromDate).isAfter(this.toDate)){
      //     this.$alert("To date cannot be before start date.","","warning");
      //     return false;
      //   }
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/excel/report-msrb-hib",
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.exporting = false;


        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.exporting = false;

        });
    },
    changeOfferStatusToSendToEcn(){
      var message = "Find priority offers from suspended and new status offers and changed to to_be_send?"
      this.$confirm(message,"CONFIRM","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
        this.loading = true;
        const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
            .post(
              config.baseUrlAutoBidder +
                "/offer/change-to-be-send-offers?cognitoSub="+authService.getUser().cognitoSub,"",
                auth
            )
            .then(() => {
              this.loading = false;
              this.$alert("In progress.","","success");
        
            })
      });

    },
    cancelOfferingUpload(){
      var message = "Cancel offering upload?"
      this.$confirm(message,"CONFIRM","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
        this.loading = true;
        const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
            .put(
              config.baseUrlAutoBidder +
                "/offer/cancel-upload",{"cancelUpload":true},
                auth
            )
            .then(() => {
              this.loading = false;
              this.$alert("In progress.","","success");
        
            })
      });

    },
    uploadDaily(){
      var message = "Daily Upload"
      this.$confirm(message,"CONFIRM","question",{confirmButtonText:"Upload",cancelButtonText : "No"}).then(() => {
        this.loading = true;
        const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
            .post(
              config.baseUrlBidSide +
                "/offer/reupload-to-be-send-offers","",
                auth
            )
            .then(() => {
              this.loading = false;
              this.getSettings();
              this.$root.$emit("dailyuploaded");
            })
      });

    },
    getSettings(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/organization/bid-settings?type=OFFER",
            auth
        )
        .then(result => {
          this.settings = result.data;

        })        
    },
    reuploadAllEcns(){
        var message = "Are you sure you want to reupload suspended offers?";
        var postData = {"ecns":["IBP","TMC","TWD","MKTX"],"cognitoSub":authService.getUser().cognitoSub};    
        this.$confirm(message,"Reupload Offers","question",{confirmButtonText:"Reupload",cancelButtonText : "No"}).then(() => {
             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
                .post(
                config.baseUrlBidSide +
                    "/offer/reupload-suspended-ecn-offers",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("Reupload in progress.","","success");
                })
        })
    },
  },
  mounted() {
    this.fromDate = this.moment().format("MM-DD-YYYY");
    this.toDate = this.moment().format("MM-DD-YYYY");
    // this.toDate = this.moment().add(1,'days').format("YYYY-MM-DD");
    this.$cognitoAuth.getUserGroup((err, role) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        //console.log(role)
        this.tenantName = role[0].split("-")[0];
        var roleArray = role.map(item => {
          return  item.split("-")[1];
        })
        roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
        roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
        roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
        roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
      }
        //console.log("curret role",this.isAdmin,this.isTrader,this.isEditor,this.isSuperAdmin);
    });
    this.getSettings();
    this.$root.$on("OFFERUPLOADCOMPLETED", () => {
      this.offerUploadStatus = null;
    });

  }
};
</script>
<style scoped>
.btn:not(:last-child){
  margin: 0px;
}
</style>